module.exports = __webpack_public_path__ + "738eac7b75d6ccd9db6c8109fed9fd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/key-white-pressed.png
// module id = 42
// module chunks = 0